import { NgModule } from "@angular/core";
import { MfaComponent } from "./features/mfa/mfa.component";
import { MfaCommonModule } from "./common/mfa-common.module";
import { UpdatePhoneNumberDialogComponent } from "./features/mfa/components/update-phone-number-dialog/update-phone-number-dialog.component";
import { AuthThrottleService } from "./features/mfa/services/auth-throttle.service";
import { MfaService } from "./features/mfa/services/mfa.service";
import { MfaGuard } from "./features/mfa/guards/mfa.guard";
import { MfaActionsInternalService } from "./features/mfa/services/mfa-actions.internal.service";
import { MfaActionsService } from "./features/mfa/services/mfa-actions.service";
import { MfaDataService } from "./features/mfa/services/mfa-data.service";
import { MfaContentComponent } from "./features/mfa/components/mfa-content/mfa-content.component";
import { MfaActionNeededComponent } from "./features/mfa/components/mfa-action-needed/mfa-action-needed.component";
import { QRCodeComponent } from "angularx-qrcode";
import { MfaAuthAppContentComponent } from "./features/mfa/components/mfa-auth-app-content/mfa-auth-app-content.component";

@NgModule({
  imports: [MfaCommonModule, QRCodeComponent],
  declarations: [
    MfaComponent,
    UpdatePhoneNumberDialogComponent,
    MfaAuthAppContentComponent,
    MfaContentComponent,
    MfaActionNeededComponent,
  ],
  exports: [MfaComponent],
  providers: [
    MfaService,
    MfaGuard,
    MfaActionsInternalService,
    MfaActionsService,
    MfaDataService,
    AuthThrottleService,
  ],
})
export class MfaModule {}
